import "./Logo.scss";

export default function Logo() {
	return (
		<h1 className="logo">
			REYDAR
		</h1>
	);
}
